export const fr = {
  changePassword: "Changer le mot de passe",
  passwordConf: "Confirmation mot de passe",
  errorText: {
    oops: "Oups! Le lien semble être expiré!",
    sendNew: "Cliquer ici pour envoyer un nouveau lien.",
    invalidLink: "Lien invalide",
  },
};
